export enum BackgroundImage {
  Chocolate = 'chocolate',
  Containers = 'containers',
  Glasses = 'glasses',
  Leaves = 'leaves',
  Pearls = 'pearls',
  Pills = 'pills',
  Windows = 'windows'
}
